import { render, staticRenderFns } from "./vsm_shell.vue?vue&type=template&id=7c3dd798&"
import script from "./vsm_shell.vue?vue&type=script&lang=js&"
export * from "./vsm_shell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports